import { getListPriceResearchQueryKey, useListPriceResearch } from "@workspace/api-client-react";

// Research can be staged outside this browser (CLI or another administrator).
// Do not inherit the app's otherwise infinite query-cache lifetime.
export function usePriceResearchOverview() {
  return useListPriceResearch({
    query: {
      queryKey: getListPriceResearchQueryKey(),
      staleTime: 30_000,
      refetchInterval: 30_000,
      refetchOnMount: "always",
      refetchOnWindowFocus: "always",
    },
  });
}
